import { gql } from "@/Common/context/subscriptions/Subscriptions";
import { GeoDetailsFragment, LocationOEMsFragment } from "@/Common/api/location/fragments";
import { AdministrationToolsIntegrationsFragment, GpsLotFragment } from "@Settings/api/AdministrationTools/fragments";

export const ADMINISTRATION_TOOLS_SUBSCRIPTION = gql`
	subscription onUpdateAdministrationTools($locationId: String!) {
		onUpdateAdministrationTools(locationId: $locationId) {
			_id
			locationId
			integrations {
				...Integrations
			}
		}
	}
	${AdministrationToolsIntegrationsFragment}
`;

export const ADMINISTRATION_TOOLS_LOTS_SUBSCRIPTION = gql`
	subscription onUpdateGpsLotsFromIngestion($locationId: String!) {
		onUpdateGpsLotsFromIngestion(locationId: $locationId) {
			_id
			locationId
			integrations {
				globalPositioningService {
					lots {
						...Lot
					}
				}
			}
		}
	}
	${GpsLotFragment}
`;

export const LOCATION_SUBSCRIPTION_QUERY = gql`
	subscription onUpdateLocation($locationId: String!) {
		onUpdateLocation(locationId: $locationId) {
			_id
			locationId
			name
			prefix
			logo
			lastEmployeeIngestionOn
			adjustmentCount
			hasMultipleBranches
			branchesFranchises
			timezone
			geoDetails {
				...GeoDetails
			}
			storePictures {
				pictureURL
			}
			oems {
				...LocationOEMs
			}
			branchesOEMs {
				...LocationOEMs
			}
			storesDetails {
				isDefaultStore
				name
				email
				geoDetails {
					...GeoDetails
				}
				timezone
			}
		}
	}
	${LocationOEMsFragment}
	${GeoDetailsFragment}
`;

export const onLoginProvider = gql`
	subscription onLoginProvider($locationId: String!) {
		onLoginProvider(locationId: $locationId) {
			_id
			locationId
			integrations {
				...Integrations
			}
		}
	}
	${AdministrationToolsIntegrationsFragment}
`;

export const onLoginKMSProvider = gql`
	subscription onLoginKMSProvider($locationId: String!) {
		onLoginKMSProvider(locationId: $locationId) {
			_id
			locationId
			integrations {
				...Integrations
			}
		}
	}
	${AdministrationToolsIntegrationsFragment}
`;

export const onLogoutKMSProvider = gql`
	subscription onLogoutKMSProvider($locationId: String!) {
		onLogoutKMSProvider(locationId: $locationId) {
			_id
			locationId
			integrations {
				...Integrations
			}
		}
	}
	${AdministrationToolsIntegrationsFragment}
`;

export const onUpdateKMSStoreAndKioskConfiguration = gql`
	subscription onUpdateKMSStoreAndKioskConfiguration($locationId: String!) {
		onUpdateKMSStoreAndKioskConfiguration(locationId: $locationId) {
			_id
			locationId
			integrations {
				...Integrations
			}
		}
	}
	${AdministrationToolsIntegrationsFragment}
`;

export const onUpdateGpsStore = gql`
	subscription onUpdateGpsStore($locationId: String!) {
		onUpdateGpsStore(locationId: $locationId) {
			_id
			locationId
			integrations {
				...Integrations
			}
		}
	}
	${AdministrationToolsIntegrationsFragment}
`;

export const onUpdateUserSubscription = gql`
	subscription onUpdateUser($_id: ID, $locationId: String) {
		onUpdateUser(_id: $_id, locationId: $locationId) {
			_id
			locationId
			fullName
			kmsUserId
		}
	}
`;

export const MANAGEMENT_SYSTEM_SUBSCRIPTION = gql`
	subscription onUpdateAdministrationToolsManagementSystem($managementSystemType: String!, $storeNumber: String!) {
		onUpdateAdministrationToolsManagementSystem(managementSystemType: $managementSystemType, storeNumber: $storeNumber) {
			locationId
			managementSystemType
			managementSystem {
				providerName
				provider
				systemTenantId
				dataSource
				userID
				hasDealerNumber
				storeNumber
				areaNumber
			}
		}
	}
`;

export const ON_UPDATE_REYNOLDS_INVENTORY_MAPPING = gql`
	subscription onUpdateReynoldsInventoryMapping($locationId: String!) {
		onUpdateReynoldsInventoryMapping(locationId: $locationId) {
			_id
			locationId
			integrations {
				dmsProvider {
					providerName
					userID
				}
				dmsSources {
					_id
					label
					value
				}
				reputationManagement {
					provider
					commissionCycleLastUpdate {
						intendedCycle
						dayOfTheMonth
					}
				}
				opportunityMining {
					_id
					provider {
						_id
						providerName
						configuration {
							associationWindow
						}
					}
				}
				reynoldsInventoryMapping {
					new {
						name
						mappedName
						isEditable
						isActive
						isCustom
					}
					preOwned {
						name
						mappedName
						isEditable
						isActive
						isCustom
					}
				}
			}
		}
	}
`;

export const UPDATE_PAYROLL_PROVIDERS_CONFIGURED_ACCOUNTS = gql`
	subscription onUpdateAdministrationToolsPayrollProviders($locationId: String!) {
		onUpdateAdministrationToolsPayrollProviders(locationId: $locationId) {
			locationId
			payrollProviders {
				providerName
				configuredAccounts {
					companyId
					displayId
					status
					statusDate
				}
			}
		}
	}
`;

export const DELETE_LOT_SUBSCRIPTION = gql`
	subscription onDeleteGpsLot($locationId: String) {
		onDeleteGpsLot(locationId: $locationId) {
			locationId
			lotId
		}
	}
`;
